import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

const ClientSlider = ({
  logos = [
    "../assets/img/client_logo_1.png",
    "../assets/img/client_logo_2.png",
    "../assets/img/client_logo_3.png",
    "../assets/img/client_logo_4.png",
    "../assets/img/client_logo_5.png",
    "../assets/img/client_logo_6.png",
    "../assets/img/client_logo_7.png",
    "../assets/img/client_logo_8.png",
  ],
}) => {
  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      loop={true}
      speed={800}
      breakpoints={{
        0: { slidesPerView: 2, spaceBetween: 20 },
        600: { slidesPerView: 4, spaceBetween: 20 },
        1000: { slidesPerView: 6, spaceBetween: 20 },
      }}
      className="ct_client_slider mt-4"
    >
      {logos.map((logo, index) => (
        <SwiperSlide key={index}>
          <img
            src={logo}
            alt={`client_logo_${index + 1}`}
            style={{ width: "100%", objectFit: "contain" }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ClientSlider;
